import { Tooltip, Typography } from "@mui/material";
import { User } from "interfaces/user";
import { FC } from "react";

interface UserCountWithTooltipProps {
  users: Partial<User>[] | Partial<User> | null | undefined;
}

export const UserCountWithTooltip: FC<UserCountWithTooltipProps> = ({
  users
}): JSX.Element => {
  if (Array.isArray(users) && users.length > 1) {
    const cellContent: JSX.Element = (
      <Typography noWrap variant="body2">
        {users.length} Assignees
      </Typography>
    );

    const tooltipTitle = users
      .map(user => `${user.first_name} ${user.last_name} (${user.email})`)
      .join("\n");

    return (
      <Tooltip title={tooltipTitle} enterDelay={500}>
        {cellContent}
      </Tooltip>
    );
  } else if (
    (users && !Array.isArray(users)) ||
    (Array.isArray(users) && users.length === 1)
  ) {
    const displayUser: Partial<User> | undefined = Array.isArray(users)
      ? users.at(0)
      : users;
    const displayUserName = `${displayUser?.first_name} ${displayUser?.last_name}`;
    const cellContent: JSX.Element = (
      <Typography noWrap variant="body2">
        {displayUserName}
      </Typography>
    );

    const tooltipTitle: JSX.Element = (
      <div
        style={{ whiteSpace: "pre-line" }}
      >{`${displayUserName} (${displayUser?.email})`}</div>
    );

    return (
      <Tooltip title={tooltipTitle} enterDelay={500}>
        {cellContent}
      </Tooltip>
    );
  } else {
    return (
      <Typography variant="body2">
        <>&mdash;</>
      </Typography>
    );
  }
};
